import { useTranslation } from 'react-i18next';
import React from 'react';
import { IconType } from '../icons/BasicIcon';
import { BasicButton, BasicButtonProps } from './BasicButton';

export enum StandardButtonType {
  OK,
  APPLY,
  SUBMIT,
  CONFIRM,
  CLEAR,
  CANCEL,
  ADD,
  REMOVE,
  CLOSE,
  RETRY,
}

const standardButtonTypeToOutputMap = {
  [StandardButtonType.OK]: { iconType: IconType.CHECK, i18nKey: 'components.buttons.ok', variant: 'contained' },
  [StandardButtonType.APPLY]: { iconType: IconType.CHECK, i18nKey: 'components.buttons.apply', variant: 'contained' },
  [StandardButtonType.SUBMIT]: { iconType: IconType.CHECK, i18nKey: 'components.buttons.submit', variant: 'contained' },
  [StandardButtonType.CONFIRM]: {
    iconType: IconType.CHECK,
    i18nKey: 'components.buttons.confirm',
    variant: 'contained',
  },
  [StandardButtonType.CLEAR]: { iconType: IconType.CLEAR, i18nKey: 'components.buttons.clear', variant: 'text' },
  [StandardButtonType.CANCEL]: { iconType: IconType.CLEAR, i18nKey: 'components.buttons.cancel', variant: 'text' },
  [StandardButtonType.ADD]: { iconType: IconType.PLUS, i18nKey: 'components.buttons.add', variant: 'contained' },
  [StandardButtonType.REMOVE]: { iconType: IconType.MINUS, i18nKey: 'components.buttons.remove', variant: 'contained' },
  [StandardButtonType.CLOSE]: { iconType: IconType.CLEAR, i18nKey: 'components.buttons.close', variant: 'text' },
  [StandardButtonType.RETRY]: { iconType: IconType.RELOAD, i18nKey: 'components.buttons.retry', variant: 'contained' },
} as const;

export type StandardButtonProps = {
  type: StandardButtonType;
  useIcon?: boolean;
} & Omit<BasicButtonProps, 'startIcon' | 'children' | 'type'>;

const StandardButton = ({ type, useIcon, onClick, ...buttonProps }: StandardButtonProps) => {
  const { t } = useTranslation();
  const { iconType, i18nKey, variant } = standardButtonTypeToOutputMap[type];
  return (
    <BasicButton
      onClick={onClick}
      {...buttonProps}
      variant={buttonProps.variant || variant}
      startIcon={useIcon ? iconType : undefined}
    >
      {t(i18nKey)}
    </BasicButton>
  );
};

export { StandardButton };
